"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// using legacy build due to PROD-218139. After upgrading node to 22+ we should be able to not use legacy build
var pdfWorkerFactory = function pdfWorkerFactory() {
  return new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url).toString();
};
var _default = exports["default"] = pdfWorkerFactory;